<template>
  <v-container class="not-found">
    <h1 class="not-found__title">Whoa.</h1>
    <p>
      The page you were looking for disappeared. Bug Zac on where to find that page!
    </p>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss">
.not-found {
  &__title {
    margin-bottom: 25px;
  }
}
</style>
